/**
 * Created by denis.gusarov on 3/9/2017.
 */

namespace Factive.Game {

    import List = Factive.Core.Linq.List;
    import Tween = Factive.Core.Tween.Tween;
    import Easing = Factive.Core.Tween.Easing;
    import Texture = PIXI.Texture;
    import DependenciesContainer = Factive.Core.DependenciesContainer;

    export class LabelView extends ViewBase {
        private _text: PIXI.Text;
        public $model;

        public get x(): number {
            return this._text.x;
        }

        public set x(value: number) {
            this._text.x = Math.round(value);
        }

        public get y(): number {
            return this._text.y;
        }

        public set y(value: number) {
            this._text.y = Math.round(value);
        }

        public get width(): number {
            return this._text.width;
        }

        public set width(value: number) {
            this._text.width = value;
        }

        public get height(): number {
            return this._text.height;
        }

        public set height(value: number) {
            this._text.height = value;
        }

        public get text(): string {
            return this._text.text;
        }

        public set text(value: string) {
            this._text.text = value;
        }

        public get alpha(): number {
            return this._text.alpha;
        }

        public set alpha(value: number) {
            this._text.alpha = value;
        }

        public get style(): PIXI.TextStyle {
            return this._text.style;
        }

        public set style(value: PIXI.TextStyle) {
            this._text.style = value;
        }

        public constructor(private _options) {
            super();
        }

        public static factory: any = {
            get (opt): LabelView {
                return new LabelView(opt);
            },
            dependency: ["Options"]
        };

        public getConfiguration(): IViewConfiguration {
            return <IViewConfiguration>{
                // sprites: {
                //     slotsSprite: "armature(" + this._options.slot + ")"
                // },
            };
        }

        public onInitialize(): void {

            let parent = this.display;//this.$sprites.get("slotsSprite");

            let textStyle = <PIXI.TextStyle>{
                fontFamily: this._options.fontFamily,
                fontSize: this._options.fontSize,
                fill: this._options.fill
            };

            if(this._options.fontWeight){
                textStyle.fontWeight = this._options.fontWeight;
            }

            if(this._options.wordWrap){
                textStyle.wordWrap = this._options.wordWrap;
            }
            if(this._options.wordWrapWidth){
                textStyle.wordWrapWidth = this._options.wordWrapWidth;
            }

            this._text = new PIXI.Text(this._options.text, textStyle);
            parent.addChild(this._text);
            this._text.x = parent.pivot.x - this._text.width / 2;
            this._text.y = parent.height - this._text.height * 2 - 4 + 5;
        }

        public dispose(){
            super.dispose();
            this.display.removeChild(this._text);
            this._text.destroy();
        }
    }
}


// WEBPACK FOOTER //
// src/typescript/Game/Views/Controls/LabelView.ts